module.exports = __webpack_public_path__ + "static/media/embassy-house.2e097ce9.svg";